import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { motion as m } from 'framer-motion';
import { BookOpen, Trophy, Lock, Zap, Shield, CreditCard, ArrowRight, Star, TrendingUp } from 'lucide-react';
export const Pricing = () => {
  const [selected, setSelected] = useState<'basic' | 'complete'>('complete');
  const [timeLeft, setTimeLeft] = useState({
    hours: 23,
    minutes: 56,
    seconds: 56
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.seconds > 0) return {
          ...prev,
          seconds: prev.seconds - 1
        };
        if (prev.minutes > 0) return {
          ...prev,
          minutes: prev.minutes - 1,
          seconds: 59
        };
        if (prev.hours > 0) return {
          ...prev,
          hours: prev.hours - 1,
          minutes: 59,
          seconds: 59
        };
        return prev;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const fmt = (val: number) => val.toString().padStart(2, '0');
  return <section className="py-20 bg-base relative overflow-hidden" id="pricing" data-id="element-204">
      {/* Soft glow background */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[900px] h-[900px] bg-radial-fuchsia opacity-40 pointer-events-none" data-id="element-205" />

      <div className="container mx-auto px-6 max-w-2xl relative z-10" data-id="element-206">
        {/* Countdown */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-8" data-id="element-207">
          <div className="flex justify-center gap-3 mb-4" data-id="element-208">
            {[{
            value: timeLeft.hours,
            label: 'HORAS'
          }, {
            value: timeLeft.minutes,
            label: 'MIN'
          }, {
            value: timeLeft.seconds,
            label: 'SEG'
          }].map((unit, i) => <div key={i} className="flex flex-col items-center" data-id="element-209">
                <div className="bg-white border-2 border-pink-medium rounded-xl px-5 py-3 shadow-sm min-w-[70px]" data-id="element-210">
                  <span className="text-3xl md:text-4xl font-bold text-fuchsia tabular-nums" data-id="element-211">
                    {fmt(unit.value)}
                  </span>
                </div>
                <span className="text-[10px] font-bold text-text-muted tracking-widest mt-1.5" data-id="element-212">
                  {unit.label}
                </span>
              </div>)}
          </div>

          <p className="text-sm font-semibold text-text-main" data-id="element-213">
            Después sube <span className="text-fuchsia" data-id="element-214">$8.000 ARS</span> y{' '}
            <u className="text-fuchsia" data-id="element-215">no vuelve a bajar</u>.
          </p>
        </motion.div>

        {/* Progress bar */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.1
      }} className="bg-white border border-pink-medium rounded-2xl p-4 mb-8 shadow-sm" data-id="element-216">
          <div className="flex items-center justify-between mb-2" data-id="element-217">
            <div className="flex items-center gap-2 text-sm font-semibold text-text-main" data-id="element-218">
              <TrendingUp className="w-4 h-4 text-fuchsia" data-id="element-219" />
              Cupos al precio de lanzamiento
            </div>
            <span className="text-sm font-bold text-gold-dark" data-id="element-220">
              68% tomados
            </span>
          </div>
          <div className="h-2.5 bg-pink-light rounded-full overflow-hidden" data-id="element-221">
            <motion.div initial={{
            width: 0
          }} whileInView={{
            width: '68%'
          }} viewport={{
            once: true
          }} transition={{
            duration: 1.2,
            ease: 'easeOut'
          }} className="h-full bg-gradient-gold rounded-full shadow-gold-glow" data-id="element-222" />
          </div>
        </motion.div>

        {/* Pricing card */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.2
      }} className="bg-white rounded-3xl shadow-soft border-2 border-pink-light p-6 md:p-8" data-id="element-223">
          <div className="text-center mb-6" data-id="element-224">
            <h2 className="text-2xl md:text-3xl font-serif font-bold text-text-main mb-2" data-id="element-225">
              Elegí tu{' '}
              <span className="text-fuchsia italic" data-id="element-226">GLOW SKIN PRO KIT</span>
            </h2>
            <p className="text-sm text-text-muted" data-id="element-227">
              Ambas opciones incluyen los 6 bonos exclusivos
            </p>
          </div>

          {/* Option 1: Basic */}
          <button onClick={() => setSelected('basic')} className={`w-full text-left p-4 rounded-2xl border-2 mb-3 transition-all ${selected === 'basic' ? 'border-fuchsia bg-pink-light/40 shadow-soft' : 'border-pink-light bg-pink-light/10 hover:border-pink-medium'}`} data-id="element-228">
            <div className="flex items-center justify-between" data-id="element-229">
              <div className="flex items-center gap-3 min-w-0" data-id="element-230">
                <div className={`w-5 h-5 rounded-full border-2 flex items-center justify-center shrink-0 ${selected === 'basic' ? 'border-fuchsia' : 'border-text-muted/40'}`} data-id="element-231">
                  {selected === 'basic' && <div className="w-2.5 h-2.5 bg-fuchsia rounded-full" data-id="element-232" />}
                </div>
                <div className="min-w-0" data-id="element-233">
                  <div className="flex items-center gap-2 mb-0.5" data-id="element-234">
                    <BookOpen className="w-4 h-4 text-fuchsia shrink-0" data-id="element-235" />
                    <span className="font-bold text-text-main text-sm md:text-base" data-id="element-236">
                      GLOW SKIN PRO KIT
                    </span>
                  </div>
                  <p className="text-xs text-text-muted truncate" data-id="element-237">
                    6 tomos + 6 bonos exclusivos
                  </p>
                </div>
              </div>
              <div className="text-right shrink-0 ml-2" data-id="element-238">
                <div className="text-xs text-text-muted line-through" data-id="element-239">
                  $34.990
                </div>
                <div className="text-lg md:text-xl font-bold text-text-main" data-id="element-240">
                  $19.990
                </div>
              </div>
            </div>
          </button>

          {/* Option 2: Complete (highlighted) */}
          <button onClick={() => setSelected('complete')} className={`w-full text-left p-4 rounded-2xl border-2 mb-6 transition-all relative ${selected === 'complete' ? 'border-gold bg-gradient-to-br from-pink-light/40 to-gold/10 shadow-gold-glow' : 'border-pink-light hover:border-gold/50'}`} data-id="element-241">
            <div className="flex items-start justify-between gap-3" data-id="element-242">
              <div className="flex items-start gap-3 min-w-0 flex-1" data-id="element-243">
                <div className={`w-5 h-5 rounded-full border-2 flex items-center justify-center shrink-0 mt-0.5 ${selected === 'complete' ? 'border-gold' : 'border-text-muted/40'}`} data-id="element-244">
                  {selected === 'complete' && <div className="w-2.5 h-2.5 bg-gold rounded-full" data-id="element-245" />}
                </div>
                <div className="min-w-0 flex-1" data-id="element-246">
                  <div className="flex items-center gap-2 mb-2" data-id="element-247">
                    <Trophy className="w-4 h-4 text-gold-dark shrink-0" data-id="element-248" />
                    <span className="font-bold text-text-main text-sm md:text-base" data-id="element-249">
                      PACK COMPLETO
                    </span>
                  </div>
                  <div className="flex flex-wrap items-center gap-1.5 mb-2" data-id="element-250">
                    <span className="inline-flex items-center gap-1 bg-gradient-gold text-white text-[10px] font-bold px-2 py-0.5 rounded-md uppercase tracking-wider" data-id="element-251">
                      <Star className="w-2.5 h-2.5 fill-white" data-id="element-252" /> Más elegido
                    </span>
                    <span className="bg-green-100 text-green-700 text-[10px] font-bold px-2 py-0.5 rounded-md uppercase" data-id="element-253">
                      Ahorrás $16.000
                    </span>
                  </div>
                  <p className="text-xs text-text-muted" data-id="element-254">
                    6 tomos + 6 bonos +{' '}
                    <span className="font-bold text-fuchsia" data-id="element-255">PRO Élite™</span>
                  </p>
                </div>
              </div>
              <div className="text-right shrink-0" data-id="element-256">
                <div className="text-xs text-text-muted line-through" data-id="element-257">
                  $43.990
                </div>
                <div className="text-lg md:text-xl font-bold text-fuchsia" data-id="element-258">
                  $27.990
                </div>
              </div>
            </div>
          </button>

          {/* CTA */}
          <m.a href={selected === 'complete' ? 'https://checkout.tusbeneficios.shop/cart/51134965481705:1' : 'https://checkout.tusbeneficios.shop/cart/51134964662505:1'} whileHover={{
          scale: 1.01
        }} whileTap={{
          scale: 0.99
        }} className="w-full bg-gradient-fuchsia text-white font-bold py-4 rounded-2xl shadow-glow flex items-center justify-center gap-3 text-sm md:text-base tracking-wide" data-id="element-259">
            SÍ, QUIERO{' '}
            {selected === 'complete' ? 'PACK COMPLETO' : 'EL PRO KIT'}
            <ArrowRight className="w-5 h-5" data-id="element-260" />
          </m.a>

          <p className="text-center text-xs italic text-text-muted mt-4" data-id="element-261">
            {selected === 'complete' ? 'La opción más elegida por alumnas que buscan el máximo nivel' : 'Acceso completo al programa de 8 módulos'}
          </p>

          {/* Trust badges */}
          <div className="mt-6 pt-5 border-t border-pink-light" data-id="element-262">
            <div className="flex flex-wrap items-center justify-center gap-x-5 gap-y-2 text-xs text-text-muted font-medium" data-id="element-263">
              <div className="flex items-center gap-1.5" data-id="element-264">
                <Lock className="w-3.5 h-3.5 text-fuchsia" data-id="element-265" />
                Pago seguro
              </div>
              <div className="flex items-center gap-1.5" data-id="element-266">
                <Zap className="w-3.5 h-3.5 text-gold" data-id="element-267" />
                Acceso en 5 min
              </div>
              <div className="flex items-center gap-1.5" data-id="element-268">
                <Shield className="w-3.5 h-3.5 text-green-600" data-id="element-269" />
                Garantía 7 días
              </div>
              <div className="flex items-center gap-1.5" data-id="element-270">
                <CreditCard className="w-3.5 h-3.5 text-fuchsia" data-id="element-271" />
                Astropay
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
};